import PropTypes from 'prop-types';
import { useDictionary } from '../../../../../../../../utilities/hooks/UseDictionary';
import PoiProviderItem from './PoiProviderItem';
import {useHistory} from 'react-router-dom'
import { NavigatorPaths } from '../../../../../../../../assets/dictionaries/NavigatorPaths';

const PoiProviders = ({details}) => {
    const dictionary  = useDictionary();
    const history = useHistory();

    const onProviderClicked = (providerItem) => {
        history.push(`/${NavigatorPaths.applications.path}?id=${providerItem.id}`);
    }
    
    return (
        <div className="detail-tab-container thin-scrollbar fade-on-load">
            <div
				className="participant-row-container"
				style={{ justifyContent: 'space-between', marginBottom: '16px' }}
			>
				<h3>
					{dictionary.poi_providers}
				</h3>
			</div>
            {
                (details?.providers && details.providers.length > 0) ? (
                    <table style={{ marginLeft: -8, borderCollapse: "collapse" }} className='provider-customer-booking-listing'>
                        <tbody>
                            {details.providers.map(item => (
                                <PoiProviderItem
                                    key={item.id}
                                    onItemCLicked={() => onProviderClicked(item)}
                                    provider={item}
                                />
                            ))}
                        </tbody>
                    </table>
                ) : (
                    <div className="empty-provider-customers-list-placeholder d-flex-center">
                        <div className="empty-provider-customers-image empty-provider-customers-details-image"/>
                        <h3
                            data-testid="no-bookings-yet-header"
                            className='empty-provider-customers-title'
                        >
                            {dictionary.poi_provider_empty_stage_label}
                        </h3>
                        <div className="text empty-provider-customers-message">
                            {dictionary.poi_provider_empty_stage_hint}
                        </div>
                    </div>
                )
            }
        </div>
    )
}

PoiProviders.propTypes = {
    details: PropTypes.object
};

export default PoiProviders;